import _ from 'lodash';
import { QueryString } from '~/utils';
import { del, get, post } from './agent';

const microsoftCalendar = {
  public: {
    authorize: ({ uri }) => post('/microsoft/calendar/authorization', { uri }),
  },

  workspace: (workspacesUrl) => {
    const url = _([workspacesUrl, 'microsoft/calendar']).compact().join('/');

    return {
      getIntegration: () => get(url.concat('/integration')),
      disconnect: () => del(url.concat('/connection')),
      getEvents: ({ start, end, timezone, excludeTimeEntryId }) =>
        get(url.concat('/events').concat(new QueryString({ start, end, timezone, excludeTimeEntryId }).toString(true))),
    };
  },
};

export default microsoftCalendar;
